export enum KeyCodeEnum {
  Backspace = 8,
  Enter = 13,
  Esc = 27,
  Space = 32,
  ArrowLeft = 37,
  ArrowUp = 38,
  ArrowRight = 39,
  ArrowDown = 40,
  KeyA = 65,
  KeyC = 67,
  KeyF = 70,
  KeyJ = 74,
  KeyK = 75,
  KeyL = 76,
  KeyM = 77,
  KeyN = 78,
  KeyR = 82,
  KeyS = 83,
  KeyT = 84,
  Slash = 191,
}
